/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./permission-dialog.vue?vue&type=template&id=74ebe79e&scoped=true&"
import script from "./permission-dialog.vue?vue&type=script&lang=js&"
export * from "./permission-dialog.vue?vue&type=script&lang=js&"
import style0 from "./permission-dialog.vue?vue&type=style&index=0&id=74ebe79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ebe79e",
  null
  
)

export default component.exports